module.exports = __webpack_public_path__ + "img/china.b2ca0d3e.svg";